{ "name": "dawn", "sunDir": [-0.80, 0.32, 0.50], "sunColor": "#FFD8B8", "sunIntensity": 2.2,
  "skyColor": "#C4BEDC", "groundColor": "#807680", "hemiIntensity": 1.0,
  "hazeAmount": 0.20, "tint": "#FFE6D6", "tintAmount": 0.06, "valueScale": 0.97 }
